import React from 'react';
import { Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { TGDConstraints, isColorAllowed } from '../../core/document';
import { DEFAULT_SWATCHES, harmonyPalette, TPaletteKind } from '../../core/palettes';

interface ColorsPanelProps {
  currentColor: string; constraints: TGDConstraints; onColor: (color: string, background: boolean) => void;
}

const ColorsPanel: React.FC<ColorsPanelProps> = ({ currentColor, constraints, onColor }) => {
  const { t } = useTranslation();
  const [background, setBackground] = React.useState(false);
  const groups: { label: string; colors: string[] }[] = constraints.lockedPalette
    ? [{ label: t('graphicDesignLesson.editor.lockedPalette'), colors: constraints.lockedPalette }]
    : [{ label: t('graphicDesignLesson.editor.swatches'), colors: DEFAULT_SWATCHES },
      ...(['complementary', 'analogous', 'triadic'] as TPaletteKind[]).map(kind => ({
        label: t(`graphicDesignLesson.editor.harmony.${kind}`),
        colors: harmonyPalette(currentColor, kind),
      }))];
  return <section className="gd-panel">
    <h3>{t('graphicDesignLesson.editor.colors')}</h3>
    <label className="gd-toggle">{t('graphicDesignLesson.editor.background')}
      <Switch checked={background} onChange={setBackground} />
    </label>
    {groups.map(group => <div key={group.label}>
      <h4>{group.label}</h4>
      <div className="gd-swatch-grid">{group.colors.map((color, index) =>
        <button type="button" key={`${color}-${index}`} className="gd-swatch"
          aria-label={color} title={color} disabled={!isColorAllowed(color, constraints)}
          style={{ backgroundColor: color }} onClick={() => onColor(color, background)} />)}
      </div>
    </div>)}
  </section>;
};

export default ColorsPanel;
